import request from '@/utils/request.js'
import { jsonToBase64 } from '@/utils/utils.js'
import { getLocalItem } from '@/utils/token'
import Cookies from 'js-cookie'

// 访客登录
export function visitorAuthLogin(data) {
  return request({
    url: '/api/v1/auth/login',
    method: 'post',
    data,
  })
}

// 与其他业务接口共用请求实例的 VITE_API_BASE_URL。
export async function completeOAuthLogin(code) {
  if (!code) throw new Error('回调参数不完整')
  const result = await request({
    url: '/api/auth/social-login',
    method: 'post',
    withCredentials: true,
    data: { provider: 'quectel', code },
  })
  if (
    result?.success === false ||
    (result?.code != null &&
      /^\d+$/.test(String(result.code)) &&
      ![0, 200].includes(Number(result.code)))
  ) {
    throw new Error(result?.message || result?.msg || '社交登录失败')
  }
  return result
}

// 退出方法
export function logout() {
  let accessToken =
    getLocalItem('access_token')?.trim() || Cookies.get('token')?.trim()
  if (!accessToken) {
    try {
      const userInfo = JSON.parse(getLocalItem('useInfo') || 'null')
      accessToken = userInfo?.access_token?.trim() || userInfo?.token?.trim()
    } catch {
      // 兼容旧登录态；损坏的用户信息不阻止清理退出态。
    }
  }
  const bearerToken = accessToken
    ? `Bearer ${accessToken.replace(/^Bearer\s+/i, '')}`
    : ''
  return request({
    url: '/api/auth/logout',
    method: 'post',
    timeout: 10000,
    headers: bearerToken
      ? { Authorization: bearerToken, 'X-Auth-Token': bearerToken }
      : {},
    skipAuthRedirect: true,
  })
}

// 校验用户名
export const checkName = (params, options = {}) => {
  return request({
    url: '/api/v1/auth/check/user',
    method: 'get',
    params,
    ...options,
  })
}

// 用户注册
export function visitorAuthRegister(data) {
  return request({
    url: '/api/v1/auth/register',
    method: 'post',
    data,
  })
}

// 用户协议
export function getUserAgreement() {
  return request({
    url: '/api/v1/server/terms_of_service',
    method: 'get',
  })
}

// 隐私政策
export function getPrivacyPolicy() {
  return request({
    url: '/api/v1/server/privacy_policy',
    method: 'get',
  })
}

// rsa加密获取密钥
export function rsaEncrypt(data) {
  return request({
    url: '/api/v1/auth/require',
    method: 'post',
    data,
  })
}

//咨询
export function getConsult(data) {
  return request({
    url: '/api/standard/algorithm/consultation',
    method: 'post',
    data,
  })
}

//埋点
export async function setTrack(data) {
  // 统计沿用原有协议；缓存损坏、未登录和上报失败均不影响业务操作。
  const readStoredJson = (key) => {
    try {
      return JSON.parse(getLocalItem(key) || 'null')
    } catch {
      return null
    }
  }
  try {
    const user_id =
      readStoredJson('useInfo')?.username ??
      readStoredJson('options')?.user_id ??
      null
    const dataBase = jsonToBase64({
      custom: data,
      user_id,
      time: Date.now(),
      event_type: 'click',
    })
    return await request({
      url: '/api/standard/logstores/track',
      method: 'get',
      params: { data: dataBase },
      adapter: 'fetch',
      fetchOptions: { keepalive: true },
      timeout: 4000,
      skipAuthRedirect: true,
      silentError: true,
    })
  } catch {
    // 埋点是尽力上报，不向用户展示统计服务错误。
    return undefined
  }
}
